import { IGettersMock } from "./getters.types";

export const mockGetters = (): IGettersMock => ({
  getLocale: jest.fn(),
  getCurrentLocation: jest.fn(),
  getSignedIn: jest.fn(),
  getLoggedUser: jest.fn(),
  getIsAdmin: jest.fn(),
  getDisclaimer: jest.fn(),
  getUsersGuide: jest.fn(),
  getCountryConfig: jest.fn(),
  getCountriesPage: jest.fn(),
  getAssignableAdapters: jest.fn(),
  getCurrenciesPage: jest.fn(),
  getSolCustomerCurrencies: jest.fn(),
  getCashCountryConfig: jest.fn(),
});
